// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".secondaryStream .question-app{height:100%;overflow:hidden}.secondaryStream .interaction-video{height:101%;width:100%}.interaction-video iframe{pointer-events:none}.secondary-stream-default-hls-caption-button{position:absolute!important;top:50%;transform:translateY(-50%);right:0;z-index:99999}", ""]);
// Exports
module.exports = exports;
